import React, { Component } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { CellRender, GridNoRecord } from "../../../../Shared/GridComponents/CommonComponents";
import clientAdminService from "../../Service/DataService";
import { currencyFormatter, history, initialDataState, successToastr } from "../../../../../HelperMethods";
import { State, toODataString } from "@progress/kendo-data-query";
import { KendoFilter } from "../../../../ReusableComponents";
import axios from "axios";
import includes from 'lodash/includes';
import { CustomMenu, DefaultActions } from "./GlobalActions";
import AlertBox from "../../../../Shared/AlertBox";
import { CLIENT_RATE_CARD_CREATE_SUCCESS_MSG, DOWNLOAD_RATE_CARD_ALERT_MESSAGE, INFO_BATCH_RATE_CARD_UPLOAD } from "../../../../Shared/AppMessages";
import RowActions from "../../../../Shared/Workflow/RowActions";
import { AlertBoxTitle, LocalizationResource } from "../../../../Shared/AppConstants";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";

export interface ExistingRateCardProps {
    showDialog: boolean;
    clientId: string;
    exisitingRateCardIds: any;
    Title: string;
    Url: string;
}

export interface ExistingRateCardState {
    data: any;
    dataState?: any;
    fileArray?: any[];
    totalCount?: number;
    showLoader?: boolean;
    onFirstLoad: boolean;
    totalExistingRates?: any;
    totalRatesProcessed?: any;
    rejectedCount?: any;
    openAlert: boolean;
}

const allowedMymeTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

const allowedFileExtentions = ["xls", "xlsx"];

export default class ExistingRateCard extends Component<ExistingRateCardProps, ExistingRateCardState> {
    public dataItem: any;
    public alertTitle;
    uploadControl: HTMLInputElement;
    alertMessage: any;
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dataState: initialDataState,
            showLoader: true,
            onFirstLoad: true,
            fileArray: [],
            openAlert: false
        };
    }

    componentDidMount() {
        this.getClientRateCard(this.state.dataState, this.props.exisitingRateCardIds);
    }

    getClientRateCard = (dataState, rateCardId) => {
        this.setState({ showLoader: true, onFirstLoad: false });
        var queryStr = `${toODataString(dataState)}`;
        let queryParams = `rateCardId in (${rateCardId})`;

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

        axios.get(`api/admin/ratecards?${`$count=true&`}${finalQueryString}`).then((res) => {
            this.setState({
                data: res.data.items,
                showLoader: false,
                dataState: dataState,
                totalCount: res.data.count
            });
        });
    }

    onDataStateChange = (changeEvent) => {
        this.getClientRateCard(changeEvent.dataState, this.props.exisitingRateCardIds);
    };

    select = (event) => {
        let fileArray = [...this.state.fileArray];
        if (event.target.files.length > 0) {
            Array.from(event.target.files).forEach((file: any) => {
                let isfileValid = false;
                console.log(file.name.split(".")[1], file.type)
                if (includes(allowedMymeTypes, file.type)) {
                    isfileValid = true;
                } else if (file.type == "") {
                    if (includes(allowedFileExtentions, file.name.split(".")[1])) {
                        isfileValid = true;
                    }
                }
                fileArray.push({ fileName: file.name, file: file, isValid: isfileValid, path: undefined });
            });
            this.importDocuments(fileArray);
        }
    }

    downloadTemplate = () => {
        const { dataState, totalExistingRates } = this.state;
        var finalState: State = {
            ...dataState,
            take: null,
            skip: 0,
        };

        if (this.state.data && this.state.data.length > 0) {
            var queryStr = `${toODataString(finalState)}`;
            let queryParams = `id in (${this.props.exisitingRateCardIds})`;
            var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

            clientAdminService.getClientRateCardTemplate(finalQueryString)
                .then((res: any) => {
                    if (res) {
                        let fileExt = ".xlsx";
                        let fileType = "application";
                        const linkSource = `data:${fileType}/${fileExt};base64,${res.data}`;
                        const downloadLink = document.createElement("a");
                        let fileName = "RateCardBatchUpload.xlsx";
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        this.alertMessage = DOWNLOAD_RATE_CARD_ALERT_MESSAGE;
                        this.alertTitle = AlertBoxTitle.RATE_CARD_BATCH_UPLOAD_ALERT;
                        this.setState({ openAlert: true });
                    }
                });
        }

    }

    importDocuments = (fileArray) => {
        let checkNewFile = fileArray !== undefined ? fileArray.filter((i) => i.isValid === true) : [];
        if (checkNewFile.length > 0) {
            let formData = new FormData();
            checkNewFile.map((item) => {
                formData.append("FormFiles", item.file);
            });
            axios
                .post(`/api/admin/ratecards/import`, formData)
                .then((response) => response)
                .then((res) => {
                    if (res) {

                        if (res.data.file) {
                            let fileExt = ".xlsx";
                            let fileType = "application";

                            const linkSource = `data:${fileType}/${fileExt};base64,${res.data.file}`;
                            const downloadLink = document.createElement("a");
                            let fileName = "ManageRateCardErrorList.xlsx";

                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                        }
                        successToastr("Batch Import Completed!");
                        this.setState({
                            totalRatesProcessed: res.data.totalCount,
                            rejectedCount: res.data.rejectedCount,
                        }, () => { this.alertMessage = INFO_BATCH_RATE_CARD_UPLOAD(this.state.totalRatesProcessed, this.state.rejectedCount); this.alertTitle = AlertBoxTitle.RATE_CARD_UPLOAD_ALERT; this.setState({ openAlert: true }); })
                    }
                })
                .catch(() => {
                    this.setState({showLoader: false});
                });
        }
    }

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
    }

    handleClose() {
        history.push('/admin/clientratecard/manage');
        successToastr(CLIENT_RATE_CARD_CREATE_SUCCESS_MSG);
    }

    render() {
        return (
            <div>
                {this.props.showDialog && (
                    <div className="containerDialog">
                        <div className="containerDialog-animation">
                            <div className="col-10 col-md-10 shadow containerDialoginside containerDialoginside-height">
                                <div className="row blue-accordion">
                                    <div className="col-12  pt-2 pb-2 fontFifteen">
                                        {this.props.Title}
                                        <span className="float-right cursorElement" onClick={() => this.handleClose()}>
                                            <FontAwesomeIcon icon={faTimes} className="mr-1" />
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 pt-2 pb-2 conflictMsg mt-2">
                                        Following rates already exist. Please use action <span className="font-weight-extra-bold">"Download Rate Card"</span>, make necessary changes to the spreadsheet and use action <span className="font-weight-extra-bold">"Import Rate Card"</span> to update the rates. On click of <span className="font-weight-extra-bold">"Close"</span> button, rates without duplicates will be added.
                                    </div>
                                </div>
                                <div className="row ml-0 mr-0 mt-2 mb-2 mt-lg-3 mb-lg-3">
                                    <Grid
                                        className="text-center kendo-grid-custom k-widget col-12 pl-0 pr-0 shadowchild heighty_formobile font-weight-normal"
                                        expandField="expanded"
                                        data={this.state.data}
                                        {...this.state.dataState}
                                        total={this.state.totalCount}
                                        onDataStateChange={this.onDataStateChange}
                                        pageable={true}
                                        pageSize={5}
                                        filterable={false}
                                        sortable={false}
                                    >
                                        <GridNoRecords>{GridNoRecord(this.state.showLoader, true)}</GridNoRecords>
                                        <GridColumn
                                            field="division"
                                            title="Division"
                                            cell={(props) => CellRender(props, "Division")}
                                            filter="text"
                                            filterable={false}
                                            sortable={false}
                                        />
                                        <GridColumn
                                            field="location"
                                            title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                            cell={(props) => CellRender(props, "Location")}
                                            filter="text"
                                            filterable={false}
                                            sortable={false}
                                        />
                                        <GridColumn
                                            field="position"
                                            title="Position"
                                            cell={(props) => CellRender(props, "Position")}
                                            filter="text"
                                            filterable={false}
                                            sortable={false}
                                        />
                                        <GridColumn
                                            field="serviceType"
                                            title="Service Type"
                                            cell={(props) => CellRender(props, "Service Type")}
                                            filter="text"
                                            filterable={false}
                                            sortable={false}
                                            width="150px"
                                        />
                                        <GridColumn
                                            field="billType"
                                            title="Bill Type"
                                            cell={(props) => CellRender(props, "Bill Type")}
                                            filter="text"
                                            filterable={false}
                                            sortable={false}
                                            width="80px"
                                        />
                                        <GridColumn
                                            field="maxBillRate"
                                            title="Max Bill Rate"
                                            headerClassName="text-right"
                                            filter="numeric"
                                            filterable={false}
                                            sortable={false}
                                            cell={(props) => {
                                                return (
                                                    <td contextMenu="Max Bill Rate"
                                                        className="pr-3 text-right"
                                                        title={props.dataItem.maxBillRate}
                                                    >
                                                        {currencyFormatter(props.dataItem.maxBillRate)}
                                                    </td>
                                                );
                                            }}
                                            width="90px"
                                        />
                                        <GridColumn
                                            field="validFrom"
                                            filter="date"
                                            format="{0:d}"
                                            editor="date"
                                            title="Valid From"
                                            cell={(props) => CellRender(props, "Valid From")}
                                            filterable={false}
                                            sortable={false}
                                            width="90px"
                                        />
                                        <GridColumn
                                            field="validTo"
                                            filter="date"
                                            format="{0:d}"
                                            editor="date"
                                            title="Valid To"
                                            cell={(props) => CellRender(props, "Valid To")}
                                            filterable={false}
                                            sortable={false}
                                            width="90px"
                                        />
                                        <GridColumn
                                            title="Action"
                                            sortable={false}
                                            width="50px"
                                            cell={(props) => (
                                                <RowActions
                                                    dataItem={props.dataItem}
                                                    currentState={""}
                                                    rowId={props.dataItem.clientDivId}
                                                    handleClick={this.handleActionClick}
                                                    defaultActions={DefaultActions(props)}
                                                />
                                            )}
                                            headerCell={() => CustomMenu(this.state.totalExistingRates, this.select, this.downloadTemplate, this.uploadControl)}
                                        />
                                    </Grid>
                                </div>
                                <div className="row mb-2 mb-lg-4 ml-0 mr-0">
                                    <div className="col-12 text-center text-right font-regular">
                                        <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => this.handleClose()}>
                                            <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {this.state.openAlert &&
                    <AlertBox
                        handleNo={() => { this.setState({ openAlert: false }) }}
                        message={this.alertMessage}
                        showModal={this.state.openAlert}
                        title={this.alertTitle ? this.alertTitle : null}
                    ></AlertBox>
                }
            </div>
        );
    }
}
